import React, { useEffect, useState } from "react";
import { MDBIcon } from "mdbreact";
import {
  Card, CardBody, CardHeader, Pagination, PaginationItem, PaginationLink,
  Table, Row, Col, CardFooter, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Label, InputGroup, FormGroup, Input
} from "reactstrap";
import ButtonGroup from "reactstrap/lib/ButtonGroup";
import pageShowing from "utils/pageShowing";
import { ExportToCsv } from 'export-to-csv';
import axios from "utils/api";
import moment from 'moment';
import "assets/custom/custom.css";
import "styles/_profile.scss";

const searchIcon = {
  position: "absolute",
  zIndex: 2,
  display: "block",
  width: "2.375rem",
  height: "2.375rem",
  lineHeight: "4rem",
  paddingLeft: "2.375rem",
  textAlign: "center",
  color: "#aaa"
};

const searchInput = {
  marginLeft: "20px",
  marginTop: "10px",
  paddingLeft: "3rem",
  width: "100%"
};

const submitButton = {
  marginLeft: "25px",
  marginTop: "10px",
  marginRight: "20px",
  height: "46px"
};

const MIDTIDProfile = () => {
  const authSession = JSON.parse(localStorage.getItem('auth'));
  const [data, setData] = useState({ dataRows: [], dataCount: null, currentPage: 1 });
  const [page, setPage] = useState({ currentPage: 1, pageSize: 6, totalCount: 0 });
  const [qrSource, setqrSource] = useState();
  const [modal, setModal] = useState(false);
  const [modalStaticQR, setModalStaticQR] = useState(false);
  const [modalRecipient, setModalRecipient] = useState(false);
  const [modalTransaction, setmodalTransaction] = useState(false);
  const [modalTitle, setmodalTitle] = useState();
  const [modalMid, setmodalMid] = useState();
  const [modalTid, setmodalTid] = useState();
  const [modalTradingName, setmodalTradingName] = useState();
  const [modalLocation, setmodalLocation] = useState();
  const [modalConf, setModalConf] = useState(false);
  const [initSeq, setinitSeq] = useState();
  const [qrDetails, setQrdetails] = useState({ mid: '', tid: '', merchantKey: '' });
  const [notificationReceiver, setNotificationReceiver] = useState({ MID: '', TID: '', RecipientID: 0 });
  const [searchParam, setSearchParam] = useState({ merchantGroupCode: '', mid: '', tid: '', coverage: 5 });
  const [userList, setUserList] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const params = {
    merchantGroupCode: authSession?.merchantGroupCode,
    currentPage: page.number,
    pageSize: 5
  };
  const pageNumbers = [];
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getProfiles(page.currentPage, page.pageSize);

      setSearchParam(searchParam => ({
        ...searchParam,
        merchantGroupCode: authSession?.merchantGroupCode
      }));
    }

    return () => {
      mounted = false;
    };
  }, []);

  const toggle = () => {
    setModal(!modal);

    //window.location.reload(false);
  }

  const toggleConf = () => {
    setModalConf(!modalConf);

    //window.location.reload(false);
  }

  const togglerecpt = () => {
    setModalRecipient(!modalRecipient);

    //window.location.reload(false);
  }
  const toggleStaticQR = () => {
    setModalStaticQR(!modalStaticQR);

    //window.scrollTo(0, 0);
  }

  const clearQrDetails = () => {
    setqrSource("");
    setQrdetails(qrDetails => ({
      ...qrDetails,
      mid: "",
      tid: "",
      merchantKey: ""
    }));
  }

  const toggleTransactions = () => setmodalTransaction(!modalTransaction);

  const handlePageChange = (event) => {
    if (!(event.value < 1 || event.value > pageNumbers[pageNumbers.length - 1])) {
      getProfiles(event.value, page.pageSize);
    }
  };

  const handleInitializeClick = (event) => {
    clearQrDetails();

    axios.get(`/merchant/getqrstring/?seqId=${event.value}`)
      .then(response => {
        const qrCodeString = response.data?.qrCodeString;
        const qrCodeDetails = response.data?.qrDetails;

        var auditlog = {
          moduleName: `Dashboard > MID & TID Profiles > Initialize`,
          accountId: authSession?.merchantGroupCode,
          username: authSession?.username,
          actionsTaken: `Initialized terminal`
        };

        axios.post('auditlog/add', { auditlog: auditlog });

        setqrSource(qrCodeString);

        setQrdetails(qrDetails => ({
          ...qrDetails,
          mid: qrCodeDetails.mid,
          tid: qrCodeDetails.tid,
          merchantKey: qrCodeDetails.merchantKey
        }));
      });

    setmodalTitle("Initialize Terminal");

    setModal(!modal);
  };

  const handleReInitializeClick = (event) => {
    setinitSeq(event.value);

    setModalConf(!modalConf);
  };

  const handleContinueReInit = () => {
    toggleConf();

    clearQrDetails();

    axios.get(`/merchant/reinitialize/?seqID=${initSeq}`)
      .then(response => {
        setqrSource(response.data.qrCodeString);

        var auditlog = {
          moduleName: `Dashboard > MID & TID Profiles > Re-Initialize Terminal`,
          accountId: authSession?.merchantGroupCode,
          username: authSession?.username,
          actionsTaken: `Re-initialized terminal`
        };

        axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });

        setQrdetails(qrDetails => ({
          ...qrDetails,
          mid: response.data.qrDetails?.mid,
          tid: response.data.qrDetails?.tid,
          merchantKey: response.data.qrDetails.merchantKey
        }));
      });

    setmodalTitle("Re-Initialize Terminal");

    setModal(!modal);
  };

  const handleViewStaticQR = (event) => {
    setLoading(true);

    clearQrDetails();

    axios.get(`/dashboard/getstaticqr`, {
      params: {
        merchantID: event.merchantid,
        mid: event.mid,
        tid: event.tid
      }
    })
      .then(response => {
        setqrSource(response.data.qrCodeString);

        var auditlog = {
          moduleName: `Dashboard > MID & TID Profiles > Static QR`,
          accountId: authSession?.merchantGroupCode,
          username: authSession?.username,
          actionsTaken: `Viewed static qr`
        };

        axios.post('auditlog/add', { auditlog: auditlog }).then((response) => { });

        setLoading(false);
      });

    setmodalTitle("Static QR");
    setmodalMid(event.mid);
    setmodalTid(event.tid);
    setmodalTradingName(event.tradingName);
    setmodalLocation(event.location);

    setModalStaticQR(!modalStaticQR);
  };

  const handleViewTransactions = (event) => {
    axios.get(`/transactioninquiry/gettransactionsviamidtid`, {
      params: {
        merchantGroupCode: searchParam?.merchantGroupCode,
        mid: event?.MID,
        tid: event?.TID,
        coverage: 5
      }
    })
      .then(response => {
        setTransactionList(response.data.transactions);

        var auditlog = {
          moduleName: `Dashboard > MID & TID Profiles`,
          accountId: authSession?.merchantGroupCode,
          username: authSession?.username,
          actionsTaken: `Viewed last 5 transactions`
        };

        axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });
      }).catch((error) => {
        console.log(error.message);
      });

    setmodalTransaction(!modalTransaction);
  };

  const handleSetReceiver = (event) => {
    axios.post(`/user/setreceiver`, { mid: notificationReceiver.MID, tid: notificationReceiver.TID, recipientID: event.value }).then(response => {
      getRecipients(notificationReceiver.MID, notificationReceiver.TID,params.merchantGroupCode);

      var auditlog = {
        moduleName: `Dashboard > MID & TID Profiles > Edit Recipient`,
        accountId: authSession?.merchantGroupCode,
        username: authSession?.username,
        actionsTaken: `Updated SMS receiver to ${event.username}`
      };

      axios.post('auditlog/add', { auditlog: auditlog }).then((response) => { });

      getProfiles(page.currentPage, page.pageSize);
    }).catch((error) => {
      console.log(error.message);
    })
  };

  const handleEditRecipient = (event) => {
    setNotificationReceiver(notificationReceiver => ({
      ...notificationReceiver,
      MID: event.MID,
      TID: event.TID
    }));

    getRecipients(event.MID, event.TID, params.merchantGroupCode);

    var auditlog = {
      moduleName: `Dashboard > MID & TID Profiles > Edit Recipient`,
      accountId: authSession?.merchantGroupCode,
      username: authSession?.username,
      actionsTaken: `Viewed list of recipients`
    };

    axios.post('auditlog/add', { auditlog: auditlog }).then((response) => { });

    setModalRecipient(!modalRecipient);
  };

  function getRecipients(mid, tid, merchantGroupCode) {
    axios.post(`/user/getbyterminalmerchantgroup`, {
      mid: mid,
      tid: tid,
      merchantGroupCode: merchantGroupCode
    })
      .then(response => {
        setUserList(response.data.user);
        setTimeout(function () {

          setModalRecipient(!modalRecipient);

        }, 200);
      })
      .catch(() => {
        console.log('There was a problem fetching recipients. Please try again later.');
      });
  };

  const getProfiles = (currentPage, pageSize) => {
    axios.post(`/dashboard/getfilteredprofile?merchantgroupcode=${authSession?.merchantGroupCode}&portaluserid=${authSession?.portalUserId}&searchValue=${searchText}&currentPage=${currentPage}&pageSize=${pageSize}`, { params })
      .then(response => {
        setData({
          dataRows: response.data?.profiles,
          dataCount: response.data?.totalItems,
          currentPage: currentPage
        });

        setPage(page => ({
          ...page,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: response.data.totalItems
        }));
      }).catch(() => {
        console.log('There was a problem fetching MID & TID profiles. Please try again later.');
      });
  };

  const handleSearchChange = (event) => {
    event.preventDefault();

    setSearchText(event.target.value);

    setPage(page => ({ ...page }));
  };


  const handleSearch = (event) => {
    event.preventDefault();

    getProfiles(1, page.pageSize);
  };

  function displayAction(initialize, seqID, device) {
    if (device === 'MOBILE') {
      if (initialize === 1) {
        return (
          <Button size="sm" className="button90" color="warning" onClick={() => handleReInitializeClick({ value: seqID })} title="Re-Initialize">
            Re-Initialize
          </Button>
        )
      } else {
        return (
          <Button size="sm" className="button90" color="success" onClick={() => handleInitializeClick({ value: seqID })} title="Initialize">
            Initialize
          </Button>
        )
      }
    }
  }

  function displayUpdateSender(recipient, userid, username) {
    if (recipient == true) {
      return (
        <Button size="sm" color="success" disabled>
          <MDBIcon icon="check-circle" fixed />
          Current
        </Button>
      )
    } else {
      return (
        <Button size="sm"
          color="info"
          onClick={() => handleSetReceiver({ value: userid, username: username })}>
          <MDBIcon icon="check-circle" fixed /> Select
        </Button>
      )
    }
  }

  const renderTransactions = () => {
    if (transactionList.length > 0) {
      return transactionList.map(tran => {
        return (
          <tr>
            <td scope="col">{tran.txnRefNo}</td>
            <td>{moment(tran.transactionDate).format('YYYY-MM-DD HH:mm:ss')}</td>
            <td scope="col">{tran.mid}</td>
            <td scope="col">{tran.tid}</td>
            <td className="text-right">{parseFloat(tran.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
            <td scope="col">{tran.status}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="6" style={{ textAlign: "center" }}>
            <Label size="lg" className="mr-sm-2"  ><i>
              <MDBIcon icon="exclamation-triangle" /> No transactions found yet.</i>
            </Label>
          </td>
        </tr>
      );
    }
  };

  const renderTable = () => {
    return data.dataRows.map(profile => {
      return (
        <tr key={profile.uniqueKey}>
          <td>{profile.tradingName}</td>
          <td>{profile.mid}</td>
          <td>{profile.tid}</td>
          <td>{profile.device}</td>
          <td>
            <InputGroup className="mb-3">
              {profile.recipient}
              <Button size="sm" color="link" className="float-right mt--1" onClick={() => handleEditRecipient({ MID: profile.mid, TID: profile.tid })}
                title="Update selected recipient who can recieve the SMS notification">
                <u>Edit</u>
              </Button>
            </InputGroup>
          </td>
          <td className="top-align text-center" colSpan="2">
            <ButtonGroup vertical>
              {displayAction(profile.initialize, profile.seqID, profile.device)}
              <Button size="sm" color="primary" onClick={() => handleViewStaticQR({ mid: profile.mid, tid: profile.tid, merchantid: profile.merchantID, tradingName: profile.tradingName, location: profile.location })}
                title="View Static QR">
                Static QR
              </Button>
              <Button size="sm" color="info" title="View Last 5 Transactions" onClick={() => handleViewTransactions({ MID: profile.mid, TID: profile.tid })}>
                View Last 5 Txns
              </Button>
            </ButtonGroup>
          </td>
        </tr>
      );
    });
  };

  const renderRecipientList = () => {
    if (userList.length>0) {
      return userList.map(contact => {
        return (
          <tr key={contact.uniqueId}>
            <td>{contact.username}</td>
            <td>{contact.email}</td>
            <td>{contact.mobileNumber}</td>
            <td>
              <center>
                {displayUpdateSender(contact.recipient, contact.portalUserID, contact.username)}
              </center>
            </td>
          </tr>
        );
      })
    }
    else {
      return (
        <tr>
          <td colSpan="6" style={{ textAlign: "center" }}>
            <Label size="sm" className="mr-sm-2"><i>
              <MDBIcon icon="exclamation-triangle" /> No assign User.</i>
            </Label>
          </td>
        </tr>
      );
    }
  };

  const exportToCsv = () => {
    axios.post(`/dashboard/getprofiles?accountId=${authSession.merchantGroupCode}`)
      .then(response => {
        const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: `MID & TID - Account ID: ${authSession?.merchantGroupCode}`,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: false,
          headers: ['Trading Name', 'Merchant ID (MID)', 'Terminal ID (TID)', 'Device', 'Recipient'],
          filename: `MID & TID-${authSession?.merchantGroupCode}`
        };

        var auditlog = {
          moduleName: `Dashboard > MID & TID Profiles`,
          accountId: authSession?.merchantGroupCode,
          username: authSession?.username,
          actionsTaken: `Downloaded profiles to excel (.csv) format`
        };

        axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });

        new ExportToCsv(options).generateCsv(response.data.profiles);
      }).catch(() => {
        console.log('There is a problem generating the profiles. Please try again later.');
      });
  }


  const renderPageNumbers = () => {
    if (page.totalCount !== null) {
      let totalPages = Math.ceil(page.totalCount / page.pageSize)
      if (totalPages > 5) {
        let maxPage = 5;
        let minPage = 1;
        if (totalPages >= maxPage) {
          if (data.currentPage >= maxPage) {
            maxPage = data.currentPage + 2;
            minPage = data.currentPage - 2;
          }

          if (minPage < 1)
            minPage = 1;

          if (maxPage >= totalPages)
            maxPage = totalPages;

          if ((maxPage - minPage) < 4)
            minPage = maxPage - 4;

          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
        else {
          if (minPage < 1)
            minPage = 1;
          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
      }
      else {
        for (let i = 1; i <= totalPages; i++) {
          pageNumbers.push(i)
        }
      }
    }

    return pageNumbers.map(number => {
      let classes = data.currentPage === number ? 'active' : '';

      return (
        <PaginationItem className={classes} key={number}>
          <PaginationLink onClick={() => handlePageChange({ value: number })}>
            {number}
          </PaginationLink>
        </PaginationItem>
      );
    });
  };

  return (
    <Row>
      <div className="col">
        <Row>
          <Col md="12" xs="12">
            <Card className="card-stats mb-4 mb-xl-0 shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col>
                    <h3 className="mb-0">MID & TID Profiles ({data.dataCount?.toLocaleString()})</h3>
                  </Col>
                  <Col>
                    <div style={{ float: 'right', marginTop: '-20px' }}>
                      <Button type="submit" outline style={submitButton} onClick={event => exportToCsv(event)} color="info" hidden={authSession?.username !== 'admin'}>
                        <MDBIcon icon="server" /> Export to excel (.csv) format</Button>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row className="search-container">
                  <Col sm="12">
                    <div>
                      <FormGroup>
                        <form className="d-flex">
                          <div className="form-group has-search w-100">
                            <span className="fa fa-search form-control-feedback" style={searchIcon}></span>
                            <Input
                              className="form-control me-2"
                              style={searchInput}
                              type="search"
                              placeholder="Search profiles here..."
                              aria-label="Search"
                              name="searchValue"
                              onChange={event => handleSearchChange(event)}
                              onKeyPress={event => { if (event.key === "Enter") { handleSearch(event) } }}
                              autoComplete="off">
                            </Input>
                          </div>
                          <Button type="submit" style={submitButton} onClick={event => handleSearch(event)} color="info">SEARCH</Button>
                        </form>
                      </FormGroup>
                    </div >
                  </Col>
                </Row>
                <Table className="align-items-center table-flush" responsive striped>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Trading Name</th>
                      <th scope="col">Merchant ID (MID)</th>
                      <th scope="col">Terminal ID (TID)</th>
                      <th scope="col">Device</th>
                      <th scope="col">Recipient</th>
                      <th scope="col" className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {renderTable()}
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  <Row className="mt-0" hidden={!(Math.ceil(page.totalCount / page.pageSize) > 1)}>
                    <Col xl="6" l="6">
                      {pageShowing(page.totalCount, page.pageSize, page.currentPage)}
                    </Col>
                    <Col xl="6">
                      <Pagination className="pagination justify-content-end mb-0" listClassName="justify-content-end mb-0">
                        <PaginationItem>
                          <PaginationLink
                            onClick={() => handlePageChange({ value: (page.currentPage - 1) })}
                            tabIndex="-1">
                            <i className="fas fa-angle-left" />
                            <span className="sr-only">
                              Previous
                            </span>
                          </PaginationLink>
                        </PaginationItem>
                        {renderPageNumbers()}
                        <PaginationItem>
                          <PaginationLink
                            onClick={() => handlePageChange({ value: (page.currentPage + 1) })}
                            tabIndex="-1">
                            <i className="fas fa-angle-right" />
                            <span className="sr-only">
                              Next
                            </span>
                          </PaginationLink>
                        </PaginationItem>
                      </Pagination>
                    </Col>
                  </Row>
                </CardFooter>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal isOpen={modal} toggle={toggle} >
        <ModalHeader toggle={toggle}>
          <Label className="modal-header">{modalTitle}</Label>
        </ModalHeader>
        <hr className="mt--4 divider" />
        <ModalBody>
          <center>
            <img src={qrSource} height="400" width="400" alt="qrImage"></img>
          </center>
          <table>
            <tr>
              <td colSpan="2">Or manually input the following details</td>
            </tr>
            <tr>
              <td>MID : </td>
              <td>{qrDetails.mid}</td>
            </tr>
            <tr>
              <td>TID : </td>
              <td>{qrDetails.tid}</td>
            </tr>
            <tr>
              <td>Merchant Key : </td>
              <td>{qrDetails.merchantKey}</td>
            </tr>
          </table>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalConf} toggle={toggleConf} >
        <ModalHeader toggle={toggleConf}>
          <Label className="modal-header">Re-Initialize Terminal</Label>
        </ModalHeader>
        <hr className="mt--4 divider" />
        <ModalBody>
          Are you sure you want to re-initialize?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleContinueReInit({ value: initSeq })}>Re-Initialize</Button>
          <Button color="info" onClick={toggleConf}>Cancel</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalRecipient} toggle={togglerecpt} size="lg">
        <ModalHeader toggle={togglerecpt}>
          <Label className="modal-header">{`Edit Recipient (${userList.length})`}</Label>
          <p>Select a recipient below who can recieve the SMS notification</p>
        </ModalHeader>
        <ModalBody>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Username</th>
                <th scope="col">Email Address</th>
                <th scope="col">Mobile Number</th>
                <th scope="col" className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {renderRecipientList()}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={togglerecpt}>Close</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalTransaction} toggle={toggleTransactions} style={{ maxWidth: '900px', width: '100%' }}>
        <ModalHeader toggle={toggleTransactions}>
          <Label className="modal-header">Last 5 Transactions</Label>
        </ModalHeader>
        <hr className="mt--4 divider" />
        <ModalBody>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Txn Reference</th>
                <th scope="col">Transaction Date</th>
                <th scope="col">Merchant ID (MID)</th>
                <th scope="col">Terminal ID (TID)</th>
                <th className="text-right">Amount</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {renderTransactions()}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalStaticQR} toggle={toggleStaticQR} >
        <ModalHeader toggle={toggleStaticQR}>
          <Label className="modal-header">{modalTitle}</Label>
        </ModalHeader>
        <hr className="mt--4 divider" />
        <ModalBody>
          <center>
            <img className="qrph-header" src="/logo/inst-qrph-transparent.png" width="290" alt="QRPh Header" />
          </center>
          <center>
            <h3 className="qr-details">{modalTradingName}</h3>
          </center>          
          <center>
            <img src={qrSource} height="290" width="290" alt="qrImage"></img>
          </center>  
          <div className="container">
            <div className="row">              
              <div className="text-Left col-sm-7 qr-mid">
                <h3 className="qr-midtid">MID: {modalMid}</h3>
              </div>
              <div className="text-right col-sm-5 qr-tid">
                <h3 className="qr-midtid">TID: {modalTid}</h3>
              </div>
            </div>
          </div>        
          {/* <center>
            <h3 className="qr-details">{modalLocation}</h3>
          </center> */}
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={toggleStaticQR}>Close</Button>
        </ModalFooter>
      </Modal>
    </Row>
  );
}

export default MIDTIDProfile;
